/** Calendly Calendar adapter — STUB. Implements CalendarPort. */
export function createCalendlyCalendar() {
  const err = () => { throw new Error("CALENDLY_NOT_IMPLEMENTED"); };
  return {
    async status() { return { status: "not_connected", vendor: "calendly" }; },
    async findAvailableSlots() { err(); },
    async bookMeeting() { err(); },
    async cancelMeeting() { err(); },
    async listEvents() { err(); },
  };
}
